import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import { Grid } from 'styled-css-grid';

import { Box } from '../../../../../Common/BoxV2';

/* stylelint-disable */
export const DoTestQuestion = (props: RenderElementProps) => {
  const { children, attributes } = props;

  return (
    <MultipleChoiceQuestionContainer
      className="do-test-exercise-short-question font-inter"
      {...attributes}
    >
      <Grid columns="minmax(0, 1fr)" gap="16px">
        {children}
      </Grid>
    </MultipleChoiceQuestionContainer>
  );
};

const MultipleChoiceQuestionContainer = styled(Box)`
  .paragraph-toggle-element,
  .image-toggle-element {
    padding: 0;
    box-shadow: none;
  }
`;
